import { render, staticRenderFns } from "./NotFoundBanner.vue?vue&type=template&id=35ce9f40&"
import script from "./NotFoundBanner.vue?vue&type=script&lang=ts&"
export * from "./NotFoundBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports